import type { GameState } from '../../types/GameState'
import type { Purchase } from '../../types/Purchase'
import type { Upgrade } from '../../types/Upgrade'

export default function checkUpgradeEligibility(
	upgrade: Upgrade,
	gameState: GameState
): boolean {
	// Preliminary check - has it been purchased already?
	// Debt should be handled in the calling function as it should result in different behaviour depending on the context
	if (gameState.upgrades?.includes(upgrade.id)) return false

	// purchased
	if (
		upgrade.conditions.purchased &&
		!upgrade.conditions.purchased.every((departmentId) =>
			gameState.purchases.some(
				(purchase: Purchase) => purchase.id === departmentId
			)
		)
	)
		return false
	// other conditions would go here but they don't exist yet

	return true
}
